export function consumePasswordResetToken(
  location: Pick<Location, 'hash' | 'pathname' | 'search'> = window.location,
  history: Pick<History, 'replaceState' | 'state'> = window.history,
): string | null {
  const fragment = location.hash.startsWith('#')
    ? location.hash.slice(1)
    : location.hash;
  const parameters = new URLSearchParams(fragment);

  if (!parameters.has('token')) return null;

  const token = parameters.get('token');
  history.replaceState(
    history.state,
    '',
    location.pathname + location.search,
  );
  if (!/^\/reset-password\/?$/u.test(location.pathname)) {
    return null;
  }
  return token !== null && token.length > 0 ? token : null;
}
